import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import axios from "axios";

import Navbar from '../../../Navbar';
import ModalRoutes from '../../ModalRoutes';
import { LoadingIcon } from '../../../Common/Loading_Icon';
import UserTiersNew from './UserTiers';
import VehicleTiersNew from './VehicleTiers';
import { Trans } from 'react-i18next';

class TiersOverview extends Component {
    constructor(props) {
        super(props);

        this.setTab = this.setTab.bind(this);

        this.state = {
            tab: "Users"
        };
    }

    componentDidMount() {
        document.title = "Tiers - FleetXPress"
    }

    setTab(type) {
        this.setState({
            tab: type
        })
    }

    render() {
        return (
            <div>
                <div className = "bkg-white-dark listviewnew">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "titlebar">
                        <div className = "titlebar-left">
                            <div className = "left">
                                <h1><Trans>Tiers</Trans></h1>
                                <div className = "btn-tabs ml-16">
                                    <a className = {"button tab px-32 tab-left" + (this.state.tab === "Users" ? " is-active" : "")} onClick={() => this.setTab("Users")}><Trans>Users</Trans></a>
                                    <a className = {"button tab px-32 tab-right" + (this.state.tab === "Vehicles" ? " is-active" : "")} onClick={() => this.setTab("Vehicles")}><Trans>Vehicle</Trans></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.tab === "Users" ?
                            <UserTiersNew history={this.props.history} match={this.props.match} location={this.props.location}/>
                        :
                            <VehicleTiersNew history={this.props.history} match={this.props.match} location={this.props.location}/>
                    }
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(TiersOverview)